import { RouteItem } from 'types/route.types';
import { RouteItemId } from 'common/enums/html.enums';
import { Routes } from 'constants/route.constants';
import { PoliciesPermissionSetItems as Permission } from 'common/constants/permissions';
import { ReactComponent as FrontDeskIcon } from 'img/icons/sidebar/check-in.svg';
import { ReactComponent as PosIcon } from 'img/icons/sidebar/cash-register.svg';
import { ReactComponent as KidIcon } from 'img/icons/sidebar/Child.svg';
import { ReactComponent as SettingsIcon } from 'img/icons/sidebar/Gear.svg';
import {
  employeesNavLink,
  homeNavLink,
  membersNavLink,
} from 'constants/routeItems/routeItemNavLink.constants';
import {
  bookingContainer,
  crmContainer,
  ptCrmContainer,
  timeclockContainer,
  daySheetContainer,
  reportsContainer,
  posContentContainer,
  clientAdjustmentsContainer,
} from 'constants/routeItems/routeItemContainer.constants';
import commonMessages from 'common/messages/messages';
import clubSettingsMessages from 'modules/club-settings/messages';

export const clubRouteItems: RouteItem[] = [
  homeNavLink,
  {
    type: 'navLink',
    id: RouteItemId.RouteItemBtnFrontDesk,
    path: Routes.FRONT_DESK,
    title: commonMessages.frontDesk,
    icon: FrontDeskIcon,
  },
  {
    type: 'navLink',
    id: RouteItemId.RouteItemBtnPos,
    path: Routes.POS,
    title: commonMessages.pos,
    icon: PosIcon,
  },
  {
    type: 'navLink',
    id: RouteItemId.RouteItemBtnKidZone,
    path: Routes.KID_ZONE,
    title: commonMessages.kidZone,
    icon: KidIcon,
  },
  { type: 'divider', id: 'clubDivider' },
  bookingContainer,
  crmContainer,
  ptCrmContainer,
  membersNavLink,
  employeesNavLink,
  timeclockContainer,
  daySheetContainer,
  reportsContainer,
  {
    type: 'navLink',
    id: RouteItemId.RouteItemBtnClubSettings,
    path: Routes.CLUB_SETTINGS,
    title: clubSettingsMessages.clubSettingsTitle,
    icon: SettingsIcon,
    permissions: [
      Permission.CLIENT_GENERAL_INFO_VIEW,
      Permission.CLIENT_BANK_INFO_VIEW,
      Permission.CLIENT_BILLING_INFO_VIEW,
      Permission.CLIENT_FEE_RATES_VIEW,
      Permission.CLIENT_PROCESSOR_CONFIGURATION_VIEW,
      Permission.CLIENT_TAXES_INFO_VIEW,
      Permission.CLIENT_OTHER_INFO_VIEW,
      Permission.CLIENT_WORKING_HOURS_VIEW,
      Permission.CLIENT_KIDZONE_SETTINGS_VIEW,
      Permission.CLIENT_INTEGRATION_VIEW,
    ],
  },
  { type: 'groupTitle', id: 'corporationName', relatesTo: [posContentContainer.id] },
  posContentContainer,
  clientAdjustmentsContainer,
];
